import React, { useEffect, useState } from "react";
import "../../HomeWork/Pending/QuestionTypes/QuestionType.css";
import { useSelector } from "react-redux";
import axios from "../../../axios";
import PdfViewer from "../../PdfViewer/PdfViewer";
import moment from "moment";
import { iconData } from "../../../iconData";
import { IP } from "../../../internalServer";
import { Player } from "video-react";
import { useLocation } from "react-router-dom";

export default function ActivityCompletedSubDetail({
  handlePendingCompletedSubDetail,
}) {
  const { state } = useLocation()
  const userId = useSelector((state) => state?.user?.currentUser?.id);
  const [isClicked, setIsClicked] = useState(false);
  const [isError, setIsError] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [handleVideoClick, setHandleVideoClick] = useState(false);
  const [homeMain, setHomeMain] = useState([]);

  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
    attachment: null,
  });
  const [activityResponse, setActivityResponse] = useState();
  const [isGettingData, setIsGettingData] = useState(true);
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
      attachment: null,
    });
  };

  useEffect(() => {
    const getResponse = async () => {
      try {
        let res = await axios.get(
          `/homework/activity/${state.activityId}/studentResult/getByStudentAndActivityId/${userId}`
        );
        let res1 = await axios.get(`/homework/activity/getById/${state.activityId}`);
        res1 && setHomeMain(res1.data.data);
        res && setActivityResponse(res.data.data);
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
      }
    };
    getResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const handleClickForVideo = (attachment) => {
    setResponseAttach(attachment);
    setHandleVideoClick(!handleVideoClick);
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const localDate = new Date(dateObj - userOffset); // Convert to local time

    const day = localDate.getDate().toString().padStart(2, "0");
    const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
    const year = localDate.getFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };


  const timeHelper2 = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const localDate = new Date(dateObj - userOffset); // Convert to local time

    const day = localDate.getDate();
    const month = localDate.getMonth() + 1;
    const year = localDate.getFullYear();
    const hours = localDate.getHours();
    const minutes = localDate.getMinutes();
    const seconds = localDate.getSeconds();

    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };


  return (
    <>
      {activityResponse ? (
        <div className="d-flex gap-1">
          <div>
            <img
              style={{ cursor: "pointer" }}
              // onClick={handlePendingCompletedSubDetail}
              onClick={() => window.history.back()}
              src="/HwImg/backArrow.png"
              alt=""
            />{" "}
            &nbsp;
          </div>
          <div className="w-100">
            <div>
              <div className="d-flex justify-content-between w-100  mb-4">
                <div className="d-flex gap-3">
                  <span className="quesHeading">{homeMain?.name}</span> &nbsp;
                  <div className="penddingButton">Completed</div>
                </div>
                <div>
                  <div>
                    <span className="subTitles">Total Marks Obtained</span> &nbsp;
                    <span className="quesHeading">
                      {activityResponse?.obtained_marks}/{homeMain?.total_marks}
                    </span>
                  </div>
                  {/* <div>
                    &nbsp; <span className="subTitles">This Question</span>{" "}
                    &nbsp;
                    <span className="subTitles">
                      {activityResponse?.obtained_marks}
                    </span>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="PendingActivitySubContainer">
              <div className="d-flex justify-content-between w-100 mt-1">
                <div>
                  <span className="subTitle2">
                    {homeMain?.subject_id?.name}
                  </span>
                  &nbsp;
                  <span>|</span> &nbsp;
                  <span className="subTitles3">Deadline</span> &nbsp;
                  <span className="subTitle2">
                    &nbsp;{timeHelper(homeMain?.deadline)}
                  </span>
                  &nbsp;
                  <span>|</span> &nbsp;
                  &nbsp;<span className="subTitles3">Submitted</span> &nbsp;
                  <span className="subTitle2">
                    &nbsp; {timeHelper(activityResponse?.submitted_on)}
                  </span>
                  &nbsp;
                  <span>|</span> &nbsp;
                  &nbsp;<span className="subTitles3">Evaluated on</span> &nbsp;
                  <span className="subTitle2">
                    &nbsp;{timeHelper(activityResponse?.evaluation_on)}
                  </span>
                  &nbsp;
                </div>
              </div>

              <div className="ActivityDtailText mt-4">
                {homeMain?.description}
              </div>

              <div className="d-flex flex-wrap gap-3 mt-4">
                {homeMain?.attachments?.length > 0 &&
                  homeMain?.attachments?.map((attachment, index) => (
                    // <div
                    //   key={index}
                    //   onClick={() =>
                    //     setPedingSubDetail({
                    //       ...pedingSubDetail,
                    //       attachment: attachment,
                    //       pdfView: true,
                    //     })
                    //   }
                    //   className="ContainerUploadedPdf d-flex gap-2 p-3"
                    // >
                    //   <div className="d-flex align-items-center">
                    //     <img
                    //       className="extention_icon"
                    //       src={`${
                    //         iconData?.find(
                    //           (i) =>
                    //             i.extension ===
                    //             attachment?.match(/\.([^.]+)$/)[1]
                    //         )?.icon
                    //       }`}
                    //       alt=""
                    //     />
                    //   </div>
                    //   <div>
                    //     <div className="pdfSub">
                    //       {homeMain?.subject_id?.name}
                    //     </div>
                    //     <div className="ChapterNamePdf">
                    //       {/* {homeMain?.chapter_id?.name} */}
                    //       {attachment?.replace(/^[^_]*_/, "")}
                    //     </div>
                    //     <div className="timePdf">
                    //       {moment(timeHelper2(homeMain?.deadline)).format(
                    //         "hh:mm a"
                    //       )}
                    //     </div>
                    //   </div>
                    // </div>
                    <div key={index}>
                      {attachment.split(".").pop() !== "mp4" ? (
                        <>
                          {attachment.split(".").pop() === "jpg" ||
                            attachment.split(".").pop() === "jpeg" ||
                            attachment.split(".").pop() === "JPEG" ||
                            attachment.split(".").pop() === "JPG" ||
                            attachment.split(".").pop() === "PNG" ||
                            attachment.split(".").pop() === "png" ? (
                            <div
                              key={index}
                              onClick={() => {
                                if (!isError) {
                                  handleClick(attachment);
                                }
                              }}
                              className="ContainerUploadedPdf d-flex gap-2 p-3"
                            >
                              <div className="d-flex align-items-center">
                                <img
                                  className="extention_icon"
                                  src={`${iconData?.find(
                                    (i) =>
                                      i.extension ===
                                      attachment?.match(/\.([^.]+)$/)[1]
                                  )?.icon
                                    }`}
                                  alt=""
                                />
                              </div>
                              <div>
                                <div className="pdfSub">
                                  {homeMain?.subject_id?.name}
                                </div>
                                <div
                                  className="ChapterNamePdf"
                                  title={attachment?.replace(/^[^_]*_/, "")}
                                >
                                  {/* {homeMain?.chapter_id?.name} */}
                                  {attachment?.replace(/^[^_]*_/, "")}
                                </div>
                                <div className="timePdf">
                                  {moment(
                                    timeHelper2(homeMain?.deadline)
                                  ).format("hh:mm a")}
                                </div>
                              </div>
                            </div>
                          ) : (
                            // <img
                            //   style={{ cursor: "pointer" }}
                            //   className="mt-3 imageWidthAndHeight"
                            //   src={IP + attachment?.replace(/^\./, "")}
                            //   alt="Thumbnail"
                            //   onClick={() => handleClick(attachment)}
                            // />
                            <div
                              key={index}
                              onClick={(e) => {
                                if (attachment.split(".").pop() === "mp3") {
                                  handleClick(attachment);
                                } else {
                                  setPedingSubDetail({
                                    ...pedingSubDetail,
                                    pdfView: true,
                                    attachment: attachment,
                                  });
                                }
                              }}
                              className="ContainerUploadedPdf d-flex gap-2 p-3"
                            >
                              <div className="d-flex align-items-center">
                                <img
                                  className="extention_icon"
                                  src={`${iconData?.find(
                                    (i) =>
                                      i.extension ===
                                      attachment?.match(/\.([^.]+)$/)[1]
                                  )?.icon
                                    }`}
                                  alt=""
                                />
                              </div>
                              <div>
                                <div className="pdfSub">
                                  {homeMain?.subject_id?.name}
                                </div>
                                <div
                                  className="ChapterNamePdf"
                                  title={attachment?.replace(/^[^_]*_/, "")}
                                >
                                  {/* {homeMain?.chapter_id?.name} */}
                                  {attachment?.replace(/^[^_]*_/, "")}
                                </div>
                                <div className="timePdf">
                                  {moment(
                                    timeHelper2(homeMain?.deadline)
                                  ).format("hh:mm a")}
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        // <div className="vidio_player mt-3 ">
                        //   <Player
                        //     className="videoPlayer"
                        //     // playsInline
                        //     // poster={poster}
                        //     src={IP + attachment?.replace(/^\./, "")}
                        //   />
                        // </div>
                        <div
                          key={index}
                          onClick={() => handleClickForVideo(attachment)}
                          className="ContainerUploadedPdf d-flex gap-2 p-3"
                        >
                          <div className="d-flex align-items-center">
                            <img
                              className="extention_icon"
                              src={`${iconData?.find(
                                (i) =>
                                  i.extension ===
                                  attachment?.match(/\.([^.]+)$/)[1]
                              )?.icon
                                }`}
                              alt=""
                            />
                          </div>
                          <div>
                            <div
                              className="pdfSub"
                              title={attachment?.replace(/^[^_]*_/, "")}
                            >
                              {homeMain?.subject_id?.name}
                            </div>
                            <div className="ChapterNamePdf">
                              {/* {homeMain?.chapter_id?.name} */}
                              {attachment?.replace(/^[^_]*_/, "")}
                            </div>
                            <div className="timePdf">
                              {moment(timeHelper2(homeMain?.deadline)).format(
                                "hh:mm a"
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>

              <div className="ActivityDtailText mt-4 pt-4">My answer</div>
              {activityResponse?.student_response?.description && activityResponse?.student_response?.description !== "" && (
                <div style={{ position: "relative" }} className="mt-3 mb-3">
                  <textarea
                    placeholder=""
                    className="textInputQuestion p-3"
                    maxLength={2500}
                    value={
                      activityResponse?.student_response?.description
                    }
                    readOnly
                  ></textarea>
                  <div
                    className="maxWordCount"
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      right: "10px",
                    }}
                  >
                    {activityResponse?.student_response?.description?.length}/
                    {2500}
                  </div>
                </div>
              )}
              <div className="d-flex gap-3">
                {activityResponse?.student_response?.attachments?.length > 0 &&
                  activityResponse?.student_response?.attachments?.map(
                    (attachment, index) => (
                      // <div className=" pt-2">
                      //   <div
                      //     onClick={() =>
                      //       setPedingSubDetail({
                      //         ...pedingSubDetail,
                      //         attachment: attachment,
                      //         pdfView: true,
                      //       })
                      //     }
                      //     key={index}
                      //     className="d-flex pdfContainer gap-2 p-2 "
                      //   >
                      //     <div className="d-flex align-items-center">
                      //       <img
                      //         className="extention_icon"
                      //         src={`${
                      //           iconData?.find(
                      //             (i) =>
                      //               i.extension ===
                      //               attachment?.match(/\.([^.]+)$/)[1]
                      //           )?.icon
                      //         }`}
                      //         alt=""
                      //       />
                      //     </div>
                      //     <div className="w-100">
                      //       <div className="pdfName">
                      //         {attachment?.replace(/^[^_]*_/, "")}
                      //       </div>
                      //       <div className="pdfFileSize">12 KB</div>
                      //     </div>
                      //   </div>
                      // </div>
                      <div key={index}>
                        {attachment.split(".").pop() !== "mp4" || attachment.split(".").pop() !== "MP4" ? (
                          <>
                            {attachment.split(".").pop() === "jpg" ||
                              attachment.split(".").pop() === "jpeg" ||
                              attachment.split(".").pop() === "JPEG" ||
                              attachment.split(".").pop() === "JPG" ||
                              attachment.split(".").pop() === "PNG" ||
                              attachment.split(".").pop() === "png" ? (
                              // <div
                              //   key={index}
                              //   onClick={() => handleClick(attachment)}
                              //   className="ContainerUploadedPdf d-flex gap-2 p-3"
                              // >
                              //   <div className="d-flex align-items-center">
                              //     <img
                              //       className="extention_icon"
                              //       src={`${
                              //         iconData?.find(
                              //           (i) =>
                              //             i.extension ===
                              //             attachment?.match(/\.([^.]+)$/)[1]
                              //         )?.icon
                              //       }`}
                              //       alt=""
                              //     />
                              //   </div>
                              //   <div>
                              //     <div className="pdfSub">
                              //       {homeMain?.subject_id?.name}
                              //     </div>
                              //     <div className="ChapterNamePdf">
                              //       {/* {homeMain?.chapter_id?.name} */}
                              //       {attachment?.replace(/^[^_]*_/, "")}
                              //     </div>
                              //     <div className="timePdf">
                              //       {moment(
                              //         timeHelper2(homeMain?.deadline)
                              //       ).format("hh:mm a")}
                              //     </div>
                              //   </div>
                              // </div>
                              <div className=" pt-2">
                                <div
                                  onClick={() => handleClick(attachment)}
                                  key={index}
                                  className="d-flex pdfContainer gap-2 p-2 "
                                >
                                  <div className="d-flex align-items-center">
                                    <img
                                      className="extention_icon"
                                      src={`${iconData?.find(
                                        (i) =>
                                          i.extension ===
                                          attachment?.match(/\.([^.]+)$/)[1]
                                      )?.icon
                                        }`}
                                      alt=""
                                    />
                                  </div>
                                  <div className="w-100">
                                    <div
                                      className="pdfName"
                                      title={attachment?.replace(/^[^_]*_/, "")}
                                    >
                                      {attachment?.replace(/^[^_]*_/, "")}
                                    </div>
                                    {
                                      activityResponse?.attachments_sizeKb.length > 0 && <div className="pdfFileSize">
                                        {
                                          activityResponse?.attachments_sizeKb[
                                          index
                                          ]
                                        }{" "}
                                        KB
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                            ) : (
                              // <img
                              //   style={{ cursor: "pointer" }}
                              //   className="mt-3 imageWidthAndHeight"
                              //   src={IP + attachment?.replace(/^\./, "")}
                              //   alt="Thumbnail"
                              //   onClick={() => handleClick(attachment)}
                              // />
                              <div className=" pt-2">
                                <div
                                  onClick={(e) =>
                                    setPedingSubDetail({
                                      ...pedingSubDetail,
                                      pdfView: true,
                                      attachment: attachment,
                                    })
                                  }
                                  key={index}
                                  className="d-flex pdfContainer gap-2 p-2 "
                                >
                                  <div className="d-flex align-items-center">
                                    <img
                                      className="extention_icon"
                                      src={`${iconData?.find(
                                        (i) =>
                                          i.extension ===
                                          attachment?.match(/\.([^.]+)$/)[1]
                                      )?.icon
                                        }`}
                                      alt=""
                                    />
                                  </div>
                                  <div className="w-100">
                                    <div
                                      className="pdfName"
                                      title={attachment?.replace(/^[^_]*_/, "")}
                                    >
                                      {attachment?.replace(/^[^_]*_/, "")}
                                    </div>
                                    {
                                      activityResponse?.attachments_sizeKb.length > 0 && (
                                        <div className="pdfFileSize">
                                          {
                                            activityResponse?.attachments_sizeKb[
                                            index
                                            ]
                                          }{" "}
                                          KB
                                        </div>
                                      )
                                    }
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          // <div className="vidio_player mt-3 ">
                          //   <Player
                          //     className="videoPlayer"
                          //     // playsInline
                          //     // poster={poster}
                          //     src={IP + attachment?.replace(/^\./, "")}
                          //   />
                          // </div>
                          <div className=" pt-2">
                            <div
                              onClick={() => handleClickForVideo(attachment)}
                              key={index}
                              className="d-flex pdfContainer gap-2 p-2 "
                            >
                              <div className="d-flex align-items-center">
                                <img
                                  className="extention_icon"
                                  src={`${iconData?.find(
                                    (i) =>
                                      i.extension ===
                                      attachment?.match(/\.([^.]+)$/)[1]
                                  )?.icon
                                    }`}
                                  alt=""
                                />
                              </div>
                              <div className="w-100">
                                <div
                                  className="pdfName"
                                  title={attachment?.replace(/^[^_]*_/, "")}
                                >
                                  {attachment?.replace(/^[^_]*_/, "")}
                                </div>
                                {activityResponse?.attachments_sizeKb.length > 0 && <div className="pdfFileSize">
                                  {activityResponse?.attachments_sizeKb[index]}{" "}
                                  KB
                                </div>}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )
                  )}
              </div>

              <div className="mt-4 pt-2">
                <div className="TeacherRemarkHeader">TEACHER’S REMARK</div>
                <div className="TeacerRemarkText mt-2">
                  {activityResponse?.comment ? activityResponse?.comment : "No Remark."}
                </div>
              </div>

              <div className="d-flex gap-3">
                {activityResponse?.attachments?.length > 0 &&
                  activityResponse?.attachments?.map((attachment, index) => (
                    <div key={index}>
                      {attachment.split(".").pop() !== "mp4" || attachment.split(".").pop() !== "MP4" ? (
                        <>
                          {attachment.split(".").pop() === "jpg" ||
                            attachment.split(".").pop() === "jpeg" ||
                            attachment.split(".").pop() === "JPEG" ||
                            attachment.split(".").pop() === "JPG" ||
                            attachment.split(".").pop() === "PNG" ||
                            attachment.split(".").pop() === "png" ? (
                            <div className=" pt-2">
                              <div
                                onClick={() => handleClick(attachment)}
                                key={index}
                                className="d-flex pdfContainer gap-2 p-2 "
                              >
                                <div className="d-flex align-items-center">
                                  <img
                                    className="extention_icon"
                                    src={`${iconData?.find(
                                      (i) =>
                                        i.extension ===
                                        attachment?.match(/\.([^.]+)$/)[1]
                                    )?.icon
                                      }`}
                                    alt=""
                                  />
                                </div>
                                <div className="w-100">
                                  <div
                                    className="pdfName"
                                    title={attachment?.replace(/^[^_]*_/, "")}
                                  >
                                    {attachment?.replace(/^[^_]*_/, "")}
                                  </div>
                                  {activityResponse?.attachments_sizeKb.length > 0 && <div className="pdfFileSize">
                                    {
                                      activityResponse?.attachments_sizeKb[
                                      index
                                      ]
                                    }{" "}
                                    KB
                                  </div>}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className=" pt-2">
                              <div
                                onClick={(e) =>
                                  setPedingSubDetail({
                                    ...pedingSubDetail,
                                    pdfView: true,
                                    attachment: attachment,
                                  })
                                }
                                key={index}
                                className="d-flex pdfContainer gap-2 p-2 "
                              >
                                <div className="d-flex align-items-center">
                                  <img
                                    className="extention_icon"
                                    src={`${iconData?.find(
                                      (i) =>
                                        i.extension ===
                                        attachment?.match(/\.([^.]+)$/)[1]
                                    )?.icon
                                      }`}
                                    alt=""
                                  />
                                </div>
                                <div className="w-100">
                                  <div
                                    className="pdfName"
                                    title={attachment?.replace(/^[^_]*_/, "")}
                                  >
                                    {attachment?.replace(/^[^_]*_/, "")}
                                  </div>
                                  {activityResponse?.attachments_sizeKb.length > 0 && <div className="pdfFileSize">
                                    {
                                      activityResponse?.attachments_sizeKb[
                                      index
                                      ]
                                    }{" "}
                                    KB
                                  </div>}
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className=" pt-2">
                          <div
                            onClick={() => handleClickForVideo(attachment)}
                            key={index}
                            className="d-flex pdfContainer gap-2 p-2 "
                          >
                            <div className="d-flex align-items-center">
                              <img
                                className="extention_icon"
                                src={`${iconData?.find(
                                  (i) =>
                                    i.extension ===
                                    attachment?.match(/\.([^.]+)$/)[1]
                                )?.icon
                                  }`}
                                alt=""
                              />
                            </div>
                            <div className="w-100">
                              <div
                                className="pdfName"
                                title={attachment?.replace(/^[^_]*_/, "")}
                              >
                                {attachment?.replace(/^[^_]*_/, "")}
                              </div>
                              {activityResponse?.attachments_sizeKb.length > 0 && <div className="pdfFileSize">
                                {activityResponse?.attachments_sizeKb[index]} KB
                              </div>}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
              <div className="mt-4 pt-2">
                <div className="TeacherRemarkHeader">CORRECT ANSWER</div>
                <div className="TeacerRemarkText mt-2">
                  {activityResponse?.activity_id?.correctAnswer?.explanation ? activityResponse?.activity_id?.correctAnswer?.explanation : "No Explanation."}
                </div>
              </div>
              {/* Correct Answer Attachment */}
              <div className="d-flex gap-3">
                {activityResponse?.activity_id?.correctAnswer?.attachment?.length > 0 &&
                  activityResponse?.activity_id?.correctAnswer?.attachment?.map((attachment, index) => (
                    <div key={index}>
                      {attachment.split(".").pop() !== "mp4" || attachment.split(".").pop() !== "MP4" ? (
                        <>
                          {attachment.split(".").pop() === "jpg" ||
                            attachment.split(".").pop() === "jpeg" ||
                            attachment.split(".").pop() === "JPEG" ||
                            attachment.split(".").pop() === "JPG" ||
                            attachment.split(".").pop() === "PNG" ||
                            attachment.split(".").pop() === "png" ? (
                            <div className=" pt-2">
                              <div
                                onClick={() => handleClick(attachment)}
                                key={index}
                                className="d-flex pdfContainer gap-2 p-2 "
                              >
                                <div className="d-flex align-items-center">
                                  <img
                                    className="extention_icon"
                                    src={`${iconData?.find(
                                      (i) =>
                                        i.extension ===
                                        attachment?.match(/\.([^.]+)$/)[1]
                                    )?.icon
                                      }`}
                                    alt=""
                                  />
                                </div>
                                <div className="w-100">
                                  <div
                                    className="pdfName"
                                    title={attachment?.replace(/^[^_]*_/, "")}
                                  >
                                    {attachment?.replace(/^[^_]*_/, "")}
                                  </div>
                                  {/* {activityResponse?.attachments_sizeKb.length > 0 && <div className="pdfFileSize">
                                    {
                                      activityResponse?.attachments_sizeKb[
                                      index
                                      ]
                                    }{" "}
                                    KB
                                  </div>} */}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className=" pt-2">
                              <div
                                onClick={(e) =>
                                  setPedingSubDetail({
                                    ...pedingSubDetail,
                                    pdfView: true,
                                    attachment: attachment,
                                  })
                                }
                                key={index}
                                className="d-flex pdfContainer gap-2 p-2 "
                              >
                                <div className="d-flex align-items-center">
                                  <img
                                    className="extention_icon"
                                    src={`${iconData?.find(
                                      (i) =>
                                        i.extension ===
                                        attachment?.match(/\.([^.]+)$/)[1]
                                    )?.icon
                                      }`}
                                    alt=""
                                  />
                                </div>
                                <div className="w-100">
                                  <div
                                    className="pdfName"
                                    title={attachment?.replace(/^[^_]*_/, "")}
                                  >
                                    {attachment?.replace(/^[^_]*_/, "")}
                                  </div>
                                  {/* {activityResponse?.attachments_sizeKb.length > 0 && <div className="pdfFileSize">
                                    {
                                      activityResponse?.attachments_sizeKb[
                                      index
                                      ]
                                    }{" "}
                                    KB
                                  </div>} */}
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className=" pt-2">
                          <div
                            onClick={() => handleClickForVideo(attachment)}
                            key={index}
                            className="d-flex pdfContainer gap-2 p-2 "
                          >
                            <div className="d-flex align-items-center">
                              <img
                                className="extention_icon"
                                src={`${iconData?.find(
                                  (i) =>
                                    i.extension ===
                                    attachment?.match(/\.([^.]+)$/)[1]
                                )?.icon
                                  }`}
                                alt=""
                              />
                            </div>
                            <div className="w-100">
                              <div
                                className="pdfName"
                                title={attachment?.replace(/^[^_]*_/, "")}
                              >
                                {attachment?.replace(/^[^_]*_/, "")}
                              </div>
                              {/* {activityResponse?.attachments_sizeKb.length > 0 && <div className="pdfFileSize">
                                {activityResponse?.attachments_sizeKb[index]} KB
                              </div>} */}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      ) : isGettingData ? (
        <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
          <img
            className="ongoing_internal_loader"
            src="/gif/LoaderDot.gif"
            alt=""
          />
        </div>
      ) : (
        <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
          <span>Activity Not Found</span>
        </div>
      )}
      {pedingSubDetail.pdfView && (
        <PdfViewer
          handleRemovePdfVivwer={handleRemovePdfVivwer}
          attachment={pedingSubDetail?.attachment}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>
                    {console.log("1st")}
                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                    {console.log("2nd")}
                    <img
                      onClick={() => {
                        setIsError(false)
                        handleClick()
                      }}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }
              {/* <img
                className="imgMain"
                src={IP + responseAttach?.replace(/^\./, "")}
                alt="Full-size"
              />
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div> */}
            </div>
          </div>
        ))}
      {handleVideoClick && (
        <div className="fullSizeImg ">
          <div className="SubfullSizeImgVideo">
            <div>
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
            </div>
            <div>
              <img
                className="crossIconImgQue"
                onClick={handleClickForVideo}
                src="/DCM-img/crossIcon.svg"
                alt="Up Arrow"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
